import { PropsWithChildren } from 'react';

import { useIsPDF } from '../internal/useIsPDF.js';

export function PDFOnly(props: PropsWithChildren) {
  const { children } = props;
  return useIsPDF() ? <>{children}</> : null;
}
